module.exports = __webpack_public_path__ + "media/images/links_bg-2e939512.png";